<template>
  <div>
    <hero-section id="hero-section" />
    <company-profile id="company-profile" />
    <industry-experience id="industry-experience" />
    <case-shows id="case-shows" />
  </div>
</template>

<script>
// 导入 HomePage 需要的所有子组件
import HeroSection from "../components/HeroSection.vue";
import CompanyProfile from "../components/CompanyProfile.vue";
import IndustryExperience from "../components/IndustryExperience.vue";
import CaseShows from "../components/CaseShows.vue";
// import ProductShowcase from '../components/ProductShowcase.vue'; // 如果用到

export default {
  name: "HomePage",
  components: {
    HeroSection,
    CompanyProfile,
    IndustryExperience,
    CaseShows,
    // ProductShowcase,
  },
  // HomePage 通常不需要自己的 data, methods 等，除非有特定于主页的逻辑
};
</script>

<style scoped>
/* 可以添加特定于主页的样式 */
</style>
